const disabledSearchInputs = ["marital_status"];

export const isEnabledSearchInput = (field: string) =>
  !disabledSearchInputs.includes(field);
